import React from 'react'
import styled from 'styled-components'

type ChapterViewCardShellProps = {
  children: React.ReactNode
  width?: number | 'full'
}

const ChapterViewCardShell = ({
  children,
  width = 'full'
}: ChapterViewCardShellProps): JSX.Element => (
  <Shell $width={width}>{children}</Shell>
)

export default ChapterViewCardShell

const Shell = styled.div<{ $width: number | 'full' }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: ${({ $width }) => ($width === 'full' ? '100%' : `${$width}px`)};
  min-width: ${({ $width }) => ($width === 'full' ? '0' : `${$width}px`)};
  flex: ${({ $width }) => ($width === 'full' ? '1 1 100%' : '0 0 auto')};
  min-height: auto;
  background: ${({ theme }) => theme.colors.backgrounds.main};
  border-radius: ${({ theme }) => theme.shape.borderRadiusBig};
  box-shadow: ${({ theme }) => theme.shadows.darkShadow};
  position: relative;
  overflow: visible;
  box-sizing: border-box;
`

export const ChapterViewCardTitle = styled.div`
  flex-shrink: 0;
  width: 100%;
  min-height: auto;
  padding: 4px 8px 0;
  box-sizing: border-box;
  font-family: Arial Black, Arial, sans-serif;
  font-size: 16px;
  font-weight: 900;
  line-height: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 9;
`

export const ChapterViewCardBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
`

export const ChapterViewBarArea = styled.div<{ $contentWidth: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${({ $contentWidth }) => $contentWidth}px;
  min-width: ${({ $contentWidth }) => $contentWidth}px;
  flex: 1;
`
